/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SupraGoalsAdd from "./Admin/SupraGoalsAdd";
import AnalysisAdd from "./Admin/AnalysisAdd";
import ExternalLinkAdd from "./Admin/ExternalLinkAdd";
import DidacticFileAdd from "./Admin/DidacticFileAdd";
import AnalysisManage from "./Admin/AnalysisManage";
import AnalysisOrder from "./Admin/AnalysisOrder.js";
import CategoriesManage from "./Admin/CategoriesManage";
import RTERegistryManage from "./Admin/RTERegistryManage";
import DataHistory from "./Admin/DataHistory";
import DataManage from "./Admin/DataManage";
import DidacticFileManage from "./Admin/DidacticFileManage";
import RTERegistryList from "./Admin/RTERegistryList";
import PopUpEditor from "./Admin/PopUpEditor";
import StrategyResultsFileEdit from "./Admin/StrategyResultsFileEdit";
import ExternalAPI from "./Admin/ExternalAPI";
import CommonBaseManage from "./Admin/CommonBaseManage";
import SupraGoalsManage from "./Admin/SupraGoalsManage";
import PassageTable from "./Admin/PassageTable";
import POIEdition from "./Admin/POIEdition";
import POIHistory from "./Admin/POIHistory";
import POIManage from "./Admin/POIManage";
import POIOrder from "./Admin/POIOrder";
import POIUserContributions from "./Admin/POIUserContributions";
import Pcaet from "./Admin/Pcaet";
import RegionScenarioTable from "./Admin/RegionScenarioTable";
import Sankeys from "./Admin/Sankeys";
import StaticFilesManage from "./Admin/StaticFilesManage";
import Statistics from "./Admin/Statistics";
import StrategyInformation from "./Admin/StrategyInformation";
import StrategyErrors from "./Admin/StrategyErrors";
import TerritoriesManage from "./Admin/TerritoriesManage";
import UserEdition from "./Admin/UserEdition";
import UsersManage from "./Admin/UsersManage";
import ZonesManage from "./Admin/ZonesManage";
import Api from "../Controllers/Api";
import config from "../settings.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { buildRegionUrl } from "../utils";
import ExternalLinksManage from "./Admin/ExternalLinksManage.js";

/**
 * This component manages the profile of the connected user
 */
class Profile extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    /**
     * Updates index of tab to open for indicators in edition mode
     * @param {indicateur} : metadata of the indicator being edited
     */
    this.moveToEditIndicatorTab = indicateur => {
      this.setState({
        tabIndicateur: this.state.tabIndicateur + 1,
        modeIndicateur: "modifier",
        indicateurCourant: indicateur
      });
    };
    this.moveToEditCommonIndicatorTab = indicateur => {
      this.setState({
        tabCommonBase: this.state.tabCommonBase + 1,
        modeCommonBase: "modifier",
        indicatorCommonBase: indicateur
      });
    };
    this.moveToEditCommonPOITab = poi => {
      this.setState({
        tabCommonBase: this.state.tabCommonBase + 1,
        modePOICommonBase: "modifier",
        poiCommonBase: poi
      });
    };
    this.goToDataTab = () => {
      this.setState({
        mainTab: 2,
        tabIndicateur: 0,
        tabCommonBase: 0
      });
    };
    /**
     * Updates the state of the component with a parameter that defines whether
     * to launch the AjoutObjectif component to add an objective or to update one.
     * @param {chaine de caractères} mode : Mode for launching the AjoutObjectif component (ajouter or mise_a_jour)
     * @param {int} objectifCourant : the characteristics of the objective to update (in the case of an update)
     */
    this.modeAjoutMiseAJourObjectifs = (mode, objectifCourant) => {
      this.setState({
        modeObjectifs: mode,
        tabIndexObjectif: this.state.tabIndexObjectif + 1,
        objectifCourant: objectifCourant
      });
    };
    this.accesPageConfiguration = analysis => {
      // We switch to the creation tab, but in update mode
      this.setState({
        configurer: true,
        donneesRegistre: analysis,
        tabIndicateur: this.state.tabIndicateur + 1,
        annee: analysis.annee
      });
    };
    /**
     * Mise à jour de l'index de l'onglet à ouvrir pour les couches POI (liste ou édition)
     * @param {tab} : index (int) of the add/modify tab of the Equipment management interface
     * @param {mode} : addition or modification
     * @param {indicateur} : metadata of equipment being editd
     */
    this.moveToEditPOITab = equipement => {
      // update the state
      this.setState({
        tabEquipements: this.state.tabEquipements + 1,
        modeEquipements: "modifier",
        equipementCourant: equipement
      });
    };
    /**
     * Update of the index of the tab to open for the data sources logo (list or edition)
     * @param {modeLogo} : addition or modification
     * @param {dataSourceLogoCourant} : metadata of the logo being edited
     */
    this.moveToEditLogoTab = dataSourceLogoCourant => {
      // update the state
      this.setState({
        modeLogo: "update",
        dataSourceLogoCourant: dataSourceLogoCourant,
        tabCustomization: this.state.tabCustomization + 1
      });
    };
    /**
     * Update of the index of the tab to open for the data didactic file (list or edition)
     * @param {tabCustomization} : index (int) of the add/modify tab of the data didactic file management interface
     * @param {modeDidacticFile} : addition or modification
     * @param {dataDidacticFile} : metadata of the didactic file being edited
     */
    this.updateTabLogo = function (mode) {
      let dataSourceLogoCourant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (mode === "update") {
        // update the state
        _this.setState({
          modeLogo: mode,
          dataSourceLogoCourant,
          tabCustomization: _this.state.tabCustomization + 1
        });
      } else {
        // update the state
        _this.setState({
          modeLogo: undefined,
          dataSourceLogoCourant: undefined,
          tabCustomization: _this.state.tabCustomization - 1
        });
      }
    };
    /**
     * Update of the index of the tab to open for the data didactic file (list or edition)
     * @param {tabCustomization} : index (int) of the add/modify tab of the data didactic file management interface
     * @param {modeDidacticFile} : addition or modification
     * @param {dataDidacticFile} : metadata of the didactic file being edited
     */
    this.updateTabDataDidacticFile = function (mode) {
      let dataCurrentDidacticFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (mode === "update") {
        // update the state
        _this.setState({
          modeDidacticFile: mode,
          dataCurrentDidacticFile,
          tabCustomization: _this.state.tabCustomization + 1
        });
      } else {
        // update the state
        _this.setState({
          modeDidacticFile: undefined,
          dataCurrentDidacticFile: undefined,
          tabCustomization: _this.state.tabCustomization - 1
        });
      }
    };
    this.state = {
      submissionWidgetOn: false,
      users: undefined,
      mainTab: 0,
      tabIndicateur: 0,
      // the tab to open by default for indicators (list or add/modify)
      tabTerritories: 0,
      // the tab to open by default for territories
      modeIndicateur: "ajouter",
      // the mode in which we open the edition tab (addition or modification)
      indicatorCommonBase: 0,
      // indicator edited when in common base
      modeCommonBase: "ajouter",
      // the mode in which we open the edition tab (addition or modification)
      poiCommonBase: 0,
      // indicator edited when in common base
      modePOICommonBase: "ajouter",
      // the mode in which we open the edition tab (addition or modification)
      tabEquipements: 0,
      // the tab to open by default for equipment (list or add/modify)
      modeEquipements: "ajouter",
      // the mode in which we open the edition tab for the equipment (addition or modification)
      modeObjectifs: "ajouter",
      tabHistory: 0,
      // défini l'onglet à ouvrir par défaut pour les historiques
      tabIndexObjectif: 0,
      tabCustomization: 0,
      objectifCourant: undefined,
      modeLogo: "add",
      // the mode in which we open the edition tab (addition or modification)
      dataSourceLogoCourant: {
        id: undefined,
        name: undefined,
        url: undefined,
        path_logo: undefined
      },
      tabCommonBase: 0,
      modeDidacticFile: "add",
      // the mode in which we open the edition tab (addition or modification)
      dataCurrentDidacticFile: {
        id: undefined,
        title: undefined,
        type: undefined
      },
      configurer: false,
      donneesRegistre: ""
    };
  }
  componentDidMount() {
    if (localStorage.getItem("access_token") !== "") {
      // Get user infos
      this.getMe();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.tabIndicateur !== prevState.tabIndicateur && this.state.tabIndicateur !== 8 // Id of the configuration tab
    ) {
      this.setState({
        configurer: false
      });
    }
    if (this.props.connected !== prevProps.connected && localStorage.getItem("access_token") !== "") {
      // Get user infos
      this.getMe();
    }
  }

  // Get infos on current connected user
  getMe() {
    var _authManager$userInfo;
    const authManager = this.props.parentApi.controller.authManager;
    if (this.props.connected && (_authManager$userInfo = authManager.userInfos) !== null && _authManager$userInfo !== void 0 && _authManager$userInfo.id) {
      this.setState({
        userInfos: authManager.userInfos
      });
    } else {
      authManager.getMe(this.props.parentApi.callbacks).then(connected => {
        if (connected) {
          this.setState({
            userInfos: authManager.userInfos
          });
        }
      });
    }
  }
  render() {
    if (!this.props.connected) {
      return /*#__PURE__*/React.createElement("div", {
        className: "account widgets full-screen-widget"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "back-to-map",
        to: "/" + this.props.parentApi.data.urlPartageable,
        "aria-label": "Retour \xE0 la carte"
      }, /*#__PURE__*/React.createElement("span", {
        className: "close close-big"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))));
    }
    // My account labels -------------------------------------------------
    let labelMyAccount = "Mon compte";
    let pdfLink = "";
    const isUserAdmin = this.state.userInfos && this.state.userInfos.profil === "admin";
    const canEditPOIContributions = this.state.userInfos && this.state.userInfos.canValidatePOIContributions;
    if (isUserAdmin) {
      labelMyAccount = "Administration";
      pdfLink = /*#__PURE__*/React.createElement("a", {
        href: "/pdf/" + this.props.parentApi.data.region + "/documentation-utilisation-interfaces-admin.pdf",
        title: "Guide de l'interface d'administration",
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "pdf-admin"
      }));
    }
    let titleTabEditionIndicateur = "Ajout d'un indicateur";
    if (this.state.modeIndicateur === "modifier") {
      titleTabEditionIndicateur = "Modifier un indicateur";
    }
    let titleTabEditionCommonBase = "Ajout d'un indicateur";
    if (this.state.modeCommonBase === "modifier") {
      titleTabEditionCommonBase = "Modifier un indicateur";
    }
    let titleTabEditionCommonPOIBase = "Ajout d'une couche POI";
    if (this.state.modePOICommonBase === "modifier") {
      titleTabEditionCommonPOIBase = "Modifier une couche POI";
    }
    let titleTabEditionObjectif = "Ajout d'un objectif supra-territorial";
    if (this.state.modeObjectifs === "mise_a_jour") {
      titleTabEditionObjectif = "Modifier un objectif supra-territorial";
    }
    // let pageRTERegistryManage = "";
    let intitulePageRTERegistryManage = "";
    if (this.state.configurer) {
      intitulePageRTERegistryManage = "Configurer " + this.state.donneesRegistre.nom;
    }
    let titleTabEditionExternalLink = "Ajout d'un lien externe";
    if (this.state.modeLogo === "update") {
      titleTabEditionExternalLink = "Modifier un lien externe";
    }
    let titleTabEditionDataDidacticFile = "Ajout d'une fiche didactique";
    if (this.state.modeDidacticFile === "update") {
      titleTabEditionDataDidacticFile = "Modifier une fiche didactique";
    }

    // My account / dashboard ----------------------------------------
    return /*#__PURE__*/React.createElement("div", {
      className: "account widgets full-screen-widget"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "back-to-map",
      to: "/" + this.props.parentApi.data.urlPartageable
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close close-big",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
      className: "panel panel-default container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "panel-heading clearfix"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "panel-title pull-left"
    }, labelMyAccount, " ", pdfLink)), /*#__PURE__*/React.createElement("div", {
      className: "panel-body user-infos"
    }, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.mainTab,
      onSelect: (index, lastIndex) => {
        this.setState({
          mainTab: index
        });
      }
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Infos personnelles"), !isUserAdmin && canEditPOIContributions && /*#__PURE__*/React.createElement(Tab, null, "Contributions aux POIs"), isUserAdmin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tab, null, "Utilisateurs"), /*#__PURE__*/React.createElement(Tab, null, "Indicateurs, donn\xE9es"), /*#__PURE__*/React.createElement(Tab, null, "Couches POI"), /*#__PURE__*/React.createElement(Tab, null, "Territoires"), /*#__PURE__*/React.createElement(Tab, null, "Stats & Historique"), /*#__PURE__*/React.createElement(Tab, null, "Strat\xE9gie territoriale"), /*#__PURE__*/React.createElement(Tab, null, "Personnalisation"), /*#__PURE__*/React.createElement(Tab, null, "Gestion du socle commun"))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(PersonnalInfo, {
      parentApi: this.props.parentApi,
      userInfos: this.state.userInfos,
      getMe: () => this.getMe()
    })), !isUserAdmin && canEditPOIContributions && /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIUserContributions, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), isUserAdmin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(UsersManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabIndicateur,
      onSelect: (index, lastIndex) => {
        this.setState({
          tabIndicateur: index,
          modeIndicateur: "ajouter"
        });
      }
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Gestion des donn\xE9es"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des indicateurs"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionIndicateur), /*#__PURE__*/React.createElement(Tab, null, "Ordre des indicateurs"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des cat\xE9gories"), /*#__PURE__*/React.createElement(Tab, null, "API externes"), /*#__PURE__*/React.createElement(Tab, null, "Diagrammes de Sankey"), /*#__PURE__*/React.createElement(Tab, null, "Donn\xE9es du registre"), intitulePageRTERegistryManage !== "" && /*#__PURE__*/React.createElement(Tab, null, intitulePageRTERegistryManage)), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(DataManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(AnalysisManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      moveToEditIndicatorTab: this.moveToEditIndicatorTab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(AnalysisAdd, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modeIndicateur,
      indicateur: this.state.indicateurCourant
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(AnalysisOrder, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(CategoriesManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(ExternalAPI, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Sankeys, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(RTERegistryList, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      callbackConfiguration: this.accesPageConfiguration
    })), intitulePageRTERegistryManage !== "" && /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(RTERegistryManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      donneesRegistre: this.state.donneesRegistre,
      configurer: this.state.configurer,
      annee: this.state.annee
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabEquipements,
      onSelect: (index, lastIndex) => this.setState({
        tabEquipements: index,
        modeEquipements: "ajouter"
      })
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Gestion des couches POI"), /*#__PURE__*/React.createElement(Tab, null, "Ajout d'une couche POI"), /*#__PURE__*/React.createElement(Tab, null, "Ordre des couches POI"), /*#__PURE__*/React.createElement(Tab, null, "Contributions des utilisateurs")), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      moveToEditPOITab: this.moveToEditPOITab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIEdition, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modeEquipements,
      equipementCourant: this.state.equipementCourant
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIOrder, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIUserContributions, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabTerritories,
      onSelect: (index, lastIndex) => {
        this.setState({
          tabTerritories: index
        });
      }
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Gestion des p\xE9rim\xE8tres"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des zones disponibles")), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(TerritoriesManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      goToDataTab: this.goToDataTab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(ZonesManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabHistory,
      onSelect: (index, lastIndex) => this.setState({
        tabHistory: index
      })
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Statistiques"), /*#__PURE__*/React.createElement(Tab, null, "Indicateurs"), /*#__PURE__*/React.createElement(Tab, null, "Couches POI")), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Statistics, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(DataHistory, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIHistory, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabIndexObjectif,
      onSelect: index => this.setState({
        tabIndexObjectif: index,
        modeObjectifs: "ajouter"
      })
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Informations g\xE9n\xE9rales"), /*#__PURE__*/React.createElement(Tab, null, "PCAET"), /*#__PURE__*/React.createElement(Tab, null, "Table de passage"), /*#__PURE__*/React.createElement(Tab, null, "Erreurs r\xE9pertori\xE9es"), /*#__PURE__*/React.createElement(Tab, null, "Export des r\xE9sultats"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des objectifs supra-territoriaux"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionObjectif), /*#__PURE__*/React.createElement(Tab, null, "Strat\xE9gies territoriales des utilisateurs de la r\xE9gion")), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(StrategyInformation, {
      parentApi: this.props.parentApi,
      connected: this.props.connected
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Pcaet, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(PassageTable, {
      parentApi: this.props.parentApi,
      connected: this.props.connected
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(StrategyErrors, {
      parentApi: this.props.parentApi,
      connected: this.props.connected
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(StrategyResultsFileEdit, {
      parentApi: this.props.parentApi,
      connected: this.props.connected
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(SupraGoalsManage, {
      parentApi: this.props.parentApi,
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      modeAjoutMiseAJourObjectifs: this.modeAjoutMiseAJourObjectifs
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(SupraGoalsAdd, {
      parentApi: this.props.parentApi,
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      objectifCourant: this.state.objectifCourant,
      mode: this.state.modeObjectifs
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(RegionScenarioTable, {
      parentApi: this.props.parentApi,
      connected: this.props.connected,
      userInfos: this.state.userInfos
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabCustomization,
      onSelect: index => this.setState({
        tabCustomization: index,
        modeDidacticFile: "add",
        modeLogo: "add"
      })
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Mise \xE0 jour des PDFs g\xE9n\xE9raux"), /*#__PURE__*/React.createElement(Tab, null, "Personnalisation pop-up accueil"), /*#__PURE__*/React.createElement(Tab, null, "Fiches didactiques"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionDataDidacticFile), /*#__PURE__*/React.createElement(Tab, null, "Liens externes"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionExternalLink)), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(StaticFilesManage, {
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(PopUpEditor, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(DidacticFileManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      updateTab: this.updateTabDataDidacticFile
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(DidacticFileAdd, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modeDidacticFile,
      dataCurrentDidacticFile: this.state.dataCurrentDidacticFile,
      updateTab: this.updateTabDataDidacticFile
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(ExternalLinksManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      updateTab: this.updateTabLogo
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(ExternalLinkAdd, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modeLogo,
      dataSourceLogoCourant: this.state.dataSourceLogoCourant
    })))), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Tabs, {
      selectedIndex: this.state.tabCommonBase,
      onSelect: (index, lastIndex) => {
        this.setState({
          tabCommonBase: index,
          modeCommonBase: "ajouter",
          modePOICommonBase: "ajouter"
        });
      }
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, "Gestion des donn\xE9es"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des indicateurs"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionCommonBase), /*#__PURE__*/React.createElement(Tab, null, "Gestion des cat\xE9gories"), /*#__PURE__*/React.createElement(Tab, null, "Gestion des couches POI"), /*#__PURE__*/React.createElement(Tab, null, titleTabEditionCommonPOIBase), /*#__PURE__*/React.createElement(Tab, null, "Historique des indicateurs"), /*#__PURE__*/React.createElement(Tab, null, "Historique des couches POI")), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(CommonBaseManage, {
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      goToDataTab: this.goToDataTab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(AnalysisManage, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      moveToEditIndicatorTab: this.moveToEditCommonIndicatorTab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(AnalysisAdd, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modeCommonBase,
      indicateur: this.state.indicatorCommonBase
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(CategoriesManage, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIManage, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      moveToEditPOITab: this.moveToEditCommonPOITab
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIEdition, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi,
      mode: this.state.modePOICommonBase,
      equipementCourant: this.state.poiCommonBase
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(DataHistory, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })), /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(POIHistory, {
      forcedRegion: "france",
      connected: this.props.connected,
      userInfos: this.state.userInfos,
      parentApi: this.props.parentApi
    })))))))));
  }
}
class PersonnalInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      newPasswordFormWidgetOn: false,
      editInfoWidgetOn: false
    };
  }
  handleNewPasswordForm(e) {
    this.setState({
      newPasswordFormWidgetOn: true
    });
  }
  handleNewPassword(e) {
    // Check if password1 = password2
    let password1 = ReactDOM.findDOMNode(this.refs["password1"]).value;
    let password2 = ReactDOM.findDOMNode(this.refs["password2"]).value;
    if (password1 !== password2) {
      this.setState({
        status: "Les mots de passe ne sont pas identiques."
      });
      return;
    }

    // Change the password
    let url = buildRegionUrl(config.user_set_new_password, this.props.parentApi.data.region);
    const body = JSON.stringify({
      new_password: password1
    });
    Api.callApi(url, body, "POST").then(response => {
      this.setState({
        status: "Votre mot de passe a bien été changé.",
        newPasswordFormWidgetOn: false
      });
    }).catch(e => this.setState({
      status: e.message
    }));
  }
  closeUserEdition() {
    this.setState({
      editInfoWidgetOn: false
    });
    this.props.getMe();
  }
  render() {
    // New password form ------------------------------------------
    let newPasswordForm = "";
    if (this.state.newPasswordFormWidgetOn) {
      newPasswordForm = /*#__PURE__*/React.createElement("div", {
        className: "panel-body user-login-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "user-password-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", null, "Nouveau mot de passe"), /*#__PURE__*/React.createElement("input", {
        type: "password",
        className: "form-inline input",
        id: "password1",
        ref: "password1"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", null, "Retapez le nouveau mot de passe"), /*#__PURE__*/React.createElement("input", {
        type: "password",
        className: "form-inline input",
        id: "password2",
        ref: "password2"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", null), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: e => this.handleNewPassword(e)
      }, "Modifier"))));
    }
    let editInfoForm = "";
    if (this.state.editInfoWidgetOn) {
      editInfoForm = /*#__PURE__*/React.createElement(UserEdition, {
        parentApi: this.props.parentApi,
        mode: "profile",
        onClose: this.closeUserEdition.bind(this)
      });
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "panel-title pull-left"
    }, "Mes informations"), /*#__PURE__*/React.createElement("div", {
      className: "block-row"
    }, this.props.userInfos && /*#__PURE__*/React.createElement("ul", {
      className: "user-meta"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Identifiant : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.id)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Pr\xE9nom : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.prenom)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Nom : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.nom)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Organisation : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.organisation)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Fonction : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.fonction)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Territoire : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, (() => {
      const {
        zoneType,
        zoneMaille,
        zoneId
      } = this.props.userInfos.territoire_predilection;
      const zoneName = this.props.parentApi.controller.zonesManager.getZoneName(zoneId, {
        zone: zoneType
      });
      return `${zoneType} - maille ${zoneMaille}` + (zoneName ? " : " + zoneName : "");
    })())), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, "Territoire s\xE9lectionn\xE9 automatiquement lors de la connexion :"), " ", /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.utiliser_territoire_predilection ? "oui" : "non")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Code postal : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.code_postal)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", null, "Profil : "), /*#__PURE__*/React.createElement("span", {
      className: "value"
    }, this.props.userInfos.profil))), /*#__PURE__*/React.createElement(Link, {
      to: "/contact"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary"
    }, "Demande de suppression de compte")), " ", /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary",
      onClick: () => this.handleNewPasswordForm()
    }, "Changer mon mot de passe"), " ", /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary",
      onClick: () => this.setState({
        editInfoWidgetOn: true
      })
    }, "Modifier mon territoire, mes informations"), newPasswordForm), /*#__PURE__*/React.createElement("div", null, this.state.status), editInfoForm);
  }
}
export default Profile;